module.exports = __webpack_public_path__ + "static/media/add assignment.4c0adceb.svg";